export default __webpack_public_path__ + "static/media/talksCardBack.f880506b.svg";